// extracted by mini-css-extract-plugin
export default {"root":"bSFJ7cDQ6S","thumbnail":"QY0fD20JWq","description":"daWFgv55nO"};